export const work_process = [
	{
		title: "Register and KYC",
		text: "In order to participate in sales on yLaunch, you must register and KYC first. You can still stake and earn YLDY without registering.",
		btn: "Start the KYC Process",
		link: "/",
	},
	{
		title: "Verify Wallet",
		text: "Once you have registered and submitted your KYC, you must verify your wallet. This is the only wallet you will be able to use for sales.",
		btn: "Verify Wallet",
		link: "/",
	},
	{
		title: "Staking",
		text: "By staking YLDY, you earn allocation in upcoming launchpad projects. If you do not want to participate in sales, you can still benefit from staking.",
		btn: "Staking",
		link: "/",
	},
	{
		title: "Select & participate",
		text: "Once you have followed steps 1 - 3 its time to select a project to get involved with, click below to see our open projects",
		btn: "Participate",
		link: "/",
	},
];
